import { useState } from "react";

import { btn3d } from "../styles/buttonStyles";

export default function ChecklistView({ travel, personal, checklist, setChecklist, loading, loadingProgress=0, onGenerate, darkMode=false, t, lang }) {
  const dm = darkMode;
  const tabs = ["packing","before","after"];
  const [activeTab, setActiveTab] = useState("packing");
  const tabLabels = { packing:t.packingTitle, before:t.beforeTitle, after:t.afterTitle };
  const tabIcons = { packing:"🧳", before:"📝", after:"🏠" };

  const items = checklist[activeTab] || [];
  const checkedCount = items.filter(i=>i.checked).length;
  const progress = items.length ? Math.round((checkedCount/items.length)*100) : 0;

  const toggle = (idx) => {
    setChecklist(prev => ({
      ...prev,
      [activeTab]: prev[activeTab].map((item, i) => i===idx ? {...item, checked:!item.checked} : item)
    }));
  };

  const checkAll = () => {
    const allChecked = items.every(i=>i.checked);
    setChecklist(prev => ({
      ...prev,
      [activeTab]: prev[activeTab].map(item => ({...item, checked:!allChecked}))
    }));
  };

  const hasAny = tabs.some(tab => (checklist[tab]||[]).length > 0);

  return (
    <div>
      {/* 생성 버튼 */}
      {!hasAny && (
        <div style={{ textAlign:"center", padding:"20px 0 24px" }}>
          <div style={{ fontSize:48, marginBottom:12 }}>📋</div>
          <p style={{ fontSize:14, fontWeight:700, color:"var(--text)", marginBottom:6 }}>
            {travel.destination} 여행을 위한 맞춤 체크리스트
          </p>
          <p style={{ fontSize:12, color:dm?"rgba(226,232,240,0.70)":"rgba(51,65,85,0.65)", marginBottom:20, lineHeight:1.8 }}>
            AI가 여행 정보를 분석해서<br/>짐 챙기기, 여행 전/후 할 일 목록을 만들어드려요
          </p>
          <button onClick={onGenerate} disabled={loading}
            className="btn3d"
            style={{ ...btn3d("primary", dm), padding:"14px 28px", minHeight:50, borderRadius:14, fontSize:14, fontWeight:800, opacity:loading?0.6:1, cursor:loading?"not-allowed":"pointer", display:"inline-flex", alignItems:"center", gap:8 }}>
            {loading ? (
              <>
                <div style={{ width:16, height:16, border:"2px solid rgba(255,255,255,0.4)", borderTopColor:"#fff", borderRadius:"50%", animation:"spin 0.8s linear infinite", flexShrink:0 }}/>
                <span>{t.genChecklistLoading}</span>
                <span style={{ fontWeight:900, minWidth:34 }}>{loadingProgress}%</span>
              </>
            ) : t.genChecklist}
          </button>
          {/* 생성 중 진행바 */}
          {loading && (
            <div style={{ marginTop:16, width:"100%", maxWidth:280, margin:"16px auto 0" }}>
              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:5 }}>
                <span style={{ fontSize:11, color:dm?"rgba(226,232,240,0.68)":"rgba(51,65,85,0.65)" }}>
                  {loadingProgress < 30 ? "📋 항목 분석 중..." : loadingProgress < 60 ? "🧳 짐 목록 구성 중..." : loadingProgress < 85 ? "📝 할 일 목록 생성 중..." : "✨ 마무리 중..."}
                </span>
                <span style={{ fontSize:12, fontWeight:900, color:"var(--accent)" }}>{loadingProgress}%</span>
              </div>
              <div style={{ height:6, background:dm?"rgba(129,140,248,0.1)":"rgba(99,102,241,0.15)", borderRadius:99 }}>
                <div style={{ height:"100%", borderRadius:99, background:"linear-gradient(90deg,var(--accent),var(--teal))", width:`${loadingProgress}%`, transition:"width 0.35s ease", boxShadow:"0 0 8px rgba(129,140,248,0.4)" }}/>
              </div>
            </div>
          )}
        </div>
      )}

      {hasAny && (
        <>
          {/* 탭 */}
          <div style={{ display:"flex", gap:0, marginBottom:16, background:dm?"rgba(129,140,248,0.06)":"rgba(99,102,241,0.10)", border:dm?"1px solid rgba(129,140,248,0.18)":"1px solid rgba(99,102,241,0.18)", borderRadius:12, padding:4 }}>
            {tabs.map(tab => (
              <button key={tab} onClick={()=>setActiveTab(tab)}
                style={{ flex:1, padding:"8px 0", borderRadius:9, border:"none", background:activeTab===tab?"var(--accent)":"transparent", color:activeTab===tab?"#fff":dm?"rgba(226,232,240,0.75)":"rgba(51,65,85,0.70)", fontWeight:800, fontSize:11, fontFamily:"inherit", cursor:"pointer", transition:"all 0.2s" }}>
                {tabIcons[tab]} {tab==="packing"?"짐":tab==="before"?"여행 전":"여행 후"}
              </button>
            ))}
          </div>

          {/* 진행도 */}
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:14 }}>
            <div style={{ flex:1, height:6, borderRadius:3, background:dm?"rgba(255,255,255,0.08)":"rgba(99,102,241,0.15)" }}>
              <div style={{ width:`${progress}%`, height:"100%", borderRadius:3, background:`linear-gradient(90deg,var(--accent),var(--teal))`, transition:"width 0.4s" }}/>
            </div>
            <span style={{ fontSize:11, fontWeight:800, color:"var(--accent)", minWidth:36 }}>{progress}%</span>
            <button onClick={checkAll}
              style={{ fontSize:10, padding:"3px 10px", borderRadius:100, border:`1px solid ${dm?"rgba(129,140,248,0.25)":"rgba(99,102,241,0.25)"}`, background:"transparent", color:"var(--accent)", fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
              {items.every(i=>i.checked)?"전체 해제":"전체 선택"}
            </button>
          </div>

          {/* 아이템 */}
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            {(checklist[activeTab]||[]).map((item, idx) => (
              <div key={idx} onClick={()=>toggle(idx)}
                style={{ display:"flex", alignItems:"center", gap:10, padding:"11px 14px", borderRadius:11, cursor:"pointer", border:`1px solid ${item.checked?dm?"rgba(78,205,196,0.35)":"rgba(42,157,143,0.3)":dm?"rgba(129,140,248,0.12)":"rgba(99,102,241,0.15)"}`, background:item.checked?dm?"rgba(78,205,196,0.10)":"rgba(200,240,230,0.7)":dm?"rgba(255,255,255,0.04)":"rgba(255,255,255,0.82)", transition:"all 0.2s" }}>
                <div style={{ width:22, height:22, borderRadius:6, border:`2px solid ${item.checked?"#4ECDC4":dm?"rgba(129,140,248,0.35)":"rgba(99,102,241,0.35)"}`, background:item.checked?"#4ECDC4":"transparent", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, transition:"all 0.2s" }}>
                  {item.checked && <span style={{ fontSize:13, color:"#fff", lineHeight:1 }}>✓</span>}
                </div>
                <div style={{ flex:1 }}>
                  <span style={{ fontSize:13, fontWeight:600, color:item.checked?dm?"rgba(226,232,240,0.55)":"rgba(51,65,85,0.45)":"var(--text)", textDecoration:item.checked?"line-through":"none", transition:"all 0.2s" }}>
                    {item.emoji} {item.text}
                  </span>
                  {item.note && <div style={{ fontSize:10, color:dm?"rgba(226,232,240,0.60)":"rgba(51,65,85,0.55)", marginTop:2 }}>{item.note}</div>}
                </div>
                {item.priority==="high" && !item.checked && (
                  <span style={{ fontSize:9, padding:"2px 7px", borderRadius:100, background:"rgba(255,80,80,0.12)", color:"#ff6060", border:"1px solid rgba(255,80,80,0.25)", fontWeight:700, flexShrink:0 }}>필수</span>
                )}
              </div>
            ))}
          </div>

          {/* 재생성 버튼 */}
          <button onClick={onGenerate} disabled={loading}
            className="btn3d"
            style={{ ...btn3d("outline", dm), marginTop:16, width:"100%", padding:"12px", minHeight:44, borderRadius:12, fontSize:12, fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
            {loading ? `🔄 생성 중... ${loadingProgress}%` : "🔄 다시 생성하기"}
          </button>
        </>
      )}
    </div>
  );
}
